import { gql } from '@apollo/client';
import { GqlProgram, GqlProgramFragment } from '../fragments/program';

export interface Variables {
  seasonId: string;
}

export interface Data {
  showProgram: GqlProgram;
}

export const QUERY = gql`
  query ShowProgram($programId: Int!) {
    showProgram(programId: $programId) {
      ...ProgramFields
    }
  }
  ${GqlProgramFragment}
`;
